export default "__VITE_ASSET__DrdAIt76__"